import { useEffect } from "react";
import HistoricoValidaciones from "components/common/HistoricoValidaciones";
import NeoTitleMain from "design/design_components/neo/title/NeoTitleMain.base";
import NeoGridContainer from "design/design_components/neo/layout/NeoGridContainer.base";
import NeoButtonSection from "design/design_components/neo/layout/NeoButtonSection.base";
import { useComponent } from "hooks";
import BotonDescargaValidaciones from "components/common/BotonDescargaValidaciones";
import useCliente from "hooks/useCliente";
import { useLocation } from "react-router-dom";
import Icono from 'design/assets/img/mnv/icons/icon-validacion.svg';

const ClientesValidaciones = (props) => {
    const componente = useComponent();
    const cliente = useCliente();
    const [lazyParams, setLazyParams] = componente.useCustomState();
    const location = useLocation();

    useEffect(() => {
        return () => { componente.desmontar(); };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        location.state?.lazyParams
            ? setLazyParams(location.state.lazyParams)
            : setLazyParams({
                first: 0,
                rows: 8,
                page: 1
            })
    }, [])


    return (<>
        <NeoGridContainer>
            <NeoTitleMain icon={Icono} title="Centro de validaciones" col="12" md="6" />
        </NeoGridContainer>

        <HistoricoValidaciones
            clienteId={cliente.id}
            lazyParams={lazyParams}
            setLazyParams={setLazyParams}
        />

        <NeoGridContainer>
            <NeoButtonSection align="right" col="12" md="6"
                extra="p-col-align-center p-flex-sm-row p-flex-column">
                <BotonDescargaValidaciones 
                    clienteId={cliente.id}
                    lazyParams={lazyParams}
                />
            </NeoButtonSection>
        </NeoGridContainer>
    </>);
};


export default ClientesValidaciones;